var CheckListViewController = (function () {
    function CheckListViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, Dialog, notify, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.Dialog = Dialog;
        this.notify = notify;
        this.settings = settings;
        this.table = { header: [], data: [], sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.programs = [];
        this.programsLoaded = false;
        this.selectedProgram = 'SVI';
        this.dataLoaded = false;
        /*this.table.header = [
          { header: 'Program', variable: 'program' },
          { header: 'Actions', variable: 'action' },
          { header: 'IOT', variable: 'iot' }
        ];*/
        this.table.header = [
            'Actions', 'Name', 'IOT', 'Active', 'Effective from', 'Deactivated'
        ];
        this.socket.forward('admin.program_checklist_view', this.$scope);
        this.$scope.$on('socket:admin.program_checklist_view', function (event, data) {
            if (data.action === 'logs-all') {
                _this.dataLoaded = true;
                if (data.success) {
                    _this.tempTable = data.dataUpdated;
                    _this.recalculateLogsTable();
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else if (data.action === 'single-log') {
                if (data.success) {
                    var items = {
                        dialogName: 'Check List change: ',
                        logInfo: data.dataUpdated,
                        admin: _this.admin
                    };
                    _this.Dialog.updateValidForm(event, items, 'detail-cl-single-log.html').then(function (dResult) {
                        if (angular.isDefined(dResult)) {
                            _this.copyLog(dResult.logInfo.singleLog);
                        }
                    });
                }
                else {
                    _this.notify.error(data.msg);
                }
            }
            else {
                alert('Unknown response');
            }
        });
    }
    CheckListViewController.prototype.recalculateLogsTable = function () {
        var _this = this;
        this.logsTable = [];
        angular.forEach(this.tempTable, function (tableItem) {
            if (tableItem.value.program === _this.selectedProgram) {
                if ((_this.admin.clSelection.selected === 'All') || (_this.admin.clSelection.selected === 'Active' && tableItem.value.active) ||
                    (_this.admin.clSelection.selected === 'Disabled' && tableItem.value.active === false) ||
                    (_this.admin.clSelection.selected === 'Not yet enabled' && angular.isUndefined(tableItem.value.active))) {
                    _this.logsTable.push(tableItem);
                }
            }
        });
    };
    /**
      editMode - Opens the edit checklist view
      @param {number} sl:            singleLog
    */
    CheckListViewController.prototype.editMode = function (sl) {
        this.$state.go('admin.checklist-edit', { sl: sl });
    };
    CheckListViewController.prototype.copyLog = function (sl) {
        this.admin.setCopySingleLog(sl);
        this.$state.go('admin.checklist-edit', { sl: 'new' });
    };
    /**
    updateMode - Opens the checklist view, in update mode
    @param {number} sl:            singleLog
  */
    CheckListViewController.prototype.updateMode = function (sl) {
        this.$state.go('admin.checklist-update', { sl: sl });
    };
    /**
      showSingleLog - Opens a dialog with the checklist questions, that were logged
      @param {string} path:   name of the cloudant document stripped of the single logs unique name parts
    */
    CheckListViewController.prototype.showSingleLog = function (sl) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminSingleLog',
                script: '/admin/admin',
                data: {
                    adminComponent: 'checklist',
                    singleLog: sl
                },
                token: this.env.user.token
            }
        });
    };
    CheckListViewController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        /*if (angular.isDefined(this.admin.config)) {
          this.admin.getGeneralConfig();
        };*/
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAdminLogs',
                script: '/admin/admin',
                data: {
                    adminComponent: 'checklist'
                },
                token: this.env.user.token
            }
        });
    };
    /**
      createNew - Creates a new checklist object in edit mode to be added
    */
    CheckListViewController.prototype.createNew = function () {
        this.$state.go('admin.checklist-edit', { sl: 'new' });
    };
    CheckListViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'admin', 'Dialog', 'notify', 'settings'];
    return CheckListViewController;
}());
var CheckListViewComponent = (function () {
    function CheckListViewComponent() {
        this.templateUrl = 'checklist-view.html';
        this.controllerAs = 'vm';
        this.controller = CheckListViewController;
    }
    return CheckListViewComponent;
}());
angular
    .module('application')
    .component('viewCheckListSection', new CheckListViewComponent());

//# sourceMappingURL=checklist.view.component.js.map
